/* eslint-disable @typescript-eslint/no-explicit-any */
export const environment = {
  host: '',
  domain: '',
  production: false,
  hostname: 'default',
  baseApiUrl: 'default',
  cognito: {
    userPoolId: 'default',
    userPoolWebClientId: 'default',
    oauth: {
      domain: 'default',
      scope: ['openid', 'email', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'default',
      redirectSignOut: 'default',
      responseType: 'token',
    },
  },
  freshHost: 'default',
  gtmCode: 'default',
  friendlyCaptchaSiteKey: 'FCMMEN435M3NDJ9B',
  featureFlag: {
    inscriptionAutonomeEnabled: 'false',
  },
};
